import FilterReportDateItens from "../../../components/filter/reportDateItens/filter";
import reqCaixa from "../../../services/reqMultiTenant/reqCaixa";
import MainReportMatrix from "../matrix";
import Form from "./form";

const FechamentoCaixa = (props) => {
	const options = {
		title: "Sessões de caixa finalizadas",
		subTitle: "Relatório de Sessões de Caixa Finalizadas",
		id: "id_caixa_fechamento", // Chave primária da linha
		ident: "fechamentoCaixa",
		identFilter: "filterFechamentoCaixa",
		identReport: "reportFechamentoCaixa",
		tableColumns: [
			{ key: "caixa", label: "Caixa", align: "center" },
			{ key: "descricao", label: "Descrição", align: "left" },
			{ key: "data_abertura", label: "Abertura", align: "center", format: "dateTime" },
			{ key: "data_fechamento", label: "Fechamento", align: "center", format: "dateTime" },
			{ key: "id_caixa_sessao", label: "Sessão", align: "center" },
			// { key: "id_caixa_fechamento", label: "Fechamento ID", align: "center" },
			{ key: "action_view", label: "Ações", align: "center" },
		],
		reportColumns: [
			{ key: "caixa", label: "Caixa", align: "center" },
			{ key: "descricao", label: "Descrição", align: "left" },
			{ key: "data_abertura", label: "Abertura", align: "center", format: "dateTime" },
			{ key: "data_fechamento", label: "Fechamento", align: "center", format: "dateTime" },
			{ key: "id_caixa_sessao", label: "Sessão", align: "center" },
		],

		showTime: true,
		hasActive: false,
		hasSaleType: false,
		hasParam: false, // Desativa o input de busca (paramValue)
		parametersDate: [{ id: 1, label: "Data de Abertura", value: "data_abertura" }],
		parametersFilter: [],
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const newFilterData = { ...filterData, page: newPage, perPage };

		const response = await reqCaixa.fechamentosPorData(newFilterData);

		return response;
	};

	return (
		<div className="flex flex-col mt-14 min-h-[calc(100vh-6.5rem)]">
			<MainReportMatrix
				options={options}
				fetch={fetch}
				FormFilter={FilterReportDateItens}
				FormAux={Form}
			></MainReportMatrix>
		</div>
	);
};

export default FechamentoCaixa;
